import { Injectable } from '@angular/core';

type AcceptedElementTypes = HTMLAnchorElement | HTMLImageElement | HTMLIFrameElement;
type AcceptedTagName = 'a' | 'img' | 'iframe';

@Injectable({
  providedIn: 'root'
})
export class GenesysUrlReplaceService {
  private static readonly DomParser = new DOMParser();
  private static readonly ReplaceTrailingSlashRegex = new RegExp(/\/$/);

  constructor() {}

  static replaceIFrameWithUrl(content: string): string {
    return this._getReplacedContent(content, 'iframe');
  }

  static replaceImageWithUrl(content: string): string {
    return this._getReplacedContent(content, 'img');
  }

  static replaceLinkWithUrl(content: string): string {
    return this._getReplacedContent(content, 'a', false);
  }

  private static _replaceElementsWithUrl(
    parsedContent: Document,
    elements: HTMLCollectionOf<AcceptedElementTypes>,
    needParagraph = true
  ): void {
    while (elements.length > 0) {
      const element = elements[0];
      const url = this._getUrlFromElement(element);

      if (url) {
        if (needParagraph) {
          this._replaceWithParagraph(parsedContent, element, url);
        } else {
          this._replaceWithSpan(parsedContent, element, url);
        }
      } else {
        element.remove();
      }
    }
  }

  private static _getReplacedContent(content: string, tagName: AcceptedTagName, needParagraph = true): string {
    const parsedContent = this.DomParser.parseFromString(content, 'text/html');
    const elements = parsedContent.getElementsByTagName(tagName);
    if (!elements.length) {
      return content;
    }
    this._replaceElementsWithUrl(parsedContent, elements, needParagraph);

    return parsedContent.body.innerHTML;
  }

  private static _replaceWithSpan(parsedContent: Document, element: AcceptedElementTypes, url: string): void {
    const paragraph = parsedContent.createElement('span');
    paragraph.innerText = url;
    element.replaceWith(paragraph);
  }

  private static _replaceWithParagraph(parsedContent: Document, element: AcceptedElementTypes, url: string): void {
    const paragraph = parsedContent.createElement('p');
    paragraph.innerText = url;
    element.replaceWith(paragraph);
  }

  private static _getUrlFromElement(element: AcceptedElementTypes): string {
    if ((element instanceof HTMLImageElement || element instanceof HTMLIFrameElement) && element.src) {
      return element.src;
    } else if (element instanceof HTMLAnchorElement && element.href) {
      const hrefWithoutTrailingSlash = element.href.replace(this.ReplaceTrailingSlashRegex, '');
      return hrefWithoutTrailingSlash;
    }
    return '';
  }
}
